import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import FlexRow from '../../../components/molecules/FlexRow'
import { useOutboundRedirect } from '../../../api/users/redirect'
import NotFoundView from '../../../components/pages/NotFoundView'
import Loading from '../../../components/molecules/Loading'

function RedirectUtility () {
  const { token } = useParams()
  const { data, isLoading, error } = useOutboundRedirect(token)

  useEffect(() => {
    if (data?.redirect?.data?.to && data?.redirect?.data?.method === 'GET') {
      window.setTimeout(() => {
        window.location.href = data.redirect.data.to
      }, 1000)
    }
  }, [data])

  if (!token) {
    return (
      <NotFoundView />
    )
  }

  if (error) {
    return (
      <NotFoundView />
    )
  }

  return (
    <FlexRow className='p-xl justify-center' style={{ minHeight: '400px' }}>
      {isLoading ? (
        <Loading />
      ) : (
        <div className='font-size-lg'>{data?.redirect?.data?.label || 'Please Wait'}</div>
      )}
    </FlexRow>
  )
}

export default RedirectUtility
